import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { hideModal } from 'actions/internal';

class AsqSurveyEmailSendoutConfirmationModal extends React.Component {
  handleCancelClick = () => {
    this.props.hideModal();
  }

  handleConfirmClick = () => {
    this.props.onConfirm();
    this.props.hideModal();
  }

  render() {
    return (
      <div className='column u-margin-top--base u-margin-bottom--base'>
        <h2 className='u-txt--base'><b>Confirm ASQ Results E-mail to Family</b></h2>
        <hr className='u-margin-top--zero'/>

        <p>When you press "Send Results Email", Sparkler will send the family their child's Ages & Stages Questionnaire results report.</p>
        <p>You can preview the report by clicking the PDF icon on the survey page.</p>

        <div className="row">
          <div className='column grow'>
            <a className='o-sp-button o-sp-button--note cs-txt-link--sp-blue' onClick={this.handleCancelClick}>Cancel</a>
          </div>
          <div className='column shrink'>
            <a className='o-sp-button o-sp-button--note o-sp-button--primary' onClick={this.handleConfirmClick}>Send Results Email</a>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(null, {
  hideModal,
})(AsqSurveyEmailSendoutConfirmationModal);
